import React from 'react';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import { Card, Alert, Col } from 'antd';
import PropTypes from 'prop-types';

const ContractEditedWarning = ({ contract }) => {

  return (
    <>
      {contract.isPdfModified &&
        <Card>
          <Col span={24}>
            <Alert
              showIcon
              type="info"
              message="Aviso de contrato editado de forma manual"
              description="Este contrato fue modificado editando su PDF. Desde ahora en adelante, solo puede ser editado
                                por un administrador descargando, modificando y volviendo a cargar el documento de forma manual."
            />
          </Col>
        </Card>
      }
    </>
  );
};

ContractEditedWarning.propTypes = {
  contract: PropTypes.object.isRequired,
};

const data = (state) => ({
  contract: state.contract.contract,
});

export default connect(data, null)(ContractEditedWarning);